import { useMutation } from 'react-query';

import {
    QueryParams,
    QueryResponse,
    overwriteTemplateFromReport as mutationFn,
} from 'api/endPoints/OverwriteTemplateFromReport';

export const useMutationOverwriteTemplateFromReport = () => {
    return useMutation<QueryResponse, QueryError, QueryParams>((params) => mutationFn(params));
};
